
export default{
    setRoles(state, msg) {
        state.roles = msg;
    } ,
    setDeptCode(state, msg) {
        state.deptCode = msg;
    },
    setBusinessLine(state, msg) {
        state.businessLine = msg;
    },
    setUserName(state, msg) {
        state.userName = msg;
    },
    setLeaderFirst(state, msg) {
        state.leaderFirst = msg;
    },
    setStaffCode(state, msg){
        state.staffCode = msg;
    },
    setStaffStatus(state, msg){
        state.staffStatus = msg;
    },
    setCrumbsArr(state, msg) {
        state.crumbsArr = msg;
    },
    setMenu(state, msg) {
        state.menu = msg;
    },
    setJumpMenu(state, msg) {
        state.jumpMenu = msg;
    },
    setLogUrl(state, msg) {
        state.logUrl = msg;
    },
    setMenuWidth(state, msg) {
        state.menuWidth = msg;
    },
    setButtons(state, msg) {
        state.buttons = msg;
    },
    setTokens(state, msg) {
        state.tokens = msg;
    },
 
    // Tabs视图和缓存
    setVisitedViews(state, msg){
        state.visitedViews = msg;
    },
    setCachedViews(state, msg){
        state.cachedViews = msg;
    },
    //路由表
    setRouteList(state, msg){
        state.routeList = msg;
    },
  
    //页面跳转带参
    setJumpParams(state, msg){
        state.JumpParams = msg;
    },

}


// WEBPACK FOOTER //
// ./src/store/mutations.js